export default function logoutAction() {
   return {
      type : "LOGOUT"
   }
}




// WEBPACK FOOTER //
// ./src/actions/logoutAction.js